import * as React from 'react';

const NegativeIconFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 21a9 9 0 100-18 9 9 0 000 18zm-1-7.4h1.8V7H11v6.6zm0 3h1.8v-1.8H11v1.8z"
            fill="#000"
        />
    </svg>
);

NegativeIconFillSvg.displayName = 'NegativeIconFillSvg';
export default NegativeIconFillSvg;
